import React, { useState, useEffect } from "react";
import { Row, Col, Input, Card, Divider, Button } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./UserProfile.css";
import constants from "../constants/constants.json";
import Axios from "axios";
import { Validation } from "../Validation/VAlidation";
import Message from "../helper/Message";
import { setUserInfo } from "../store/actions/user";
import { useDispatch, useSelector } from "react-redux";

export default function UserProfile(props) {
  const personal = useSelector((state) => state.userReducer.personal);
  const [editInfo, setEditInfo] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nameRequire, setNameRequire] = useState(false);
  const [mailRequire, setMailRequire] = useState(false);
  const [mailValid, setMailValid] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setName(personal.name);
    setEmail(personal.email);
  }, [personal]);
  const EditInfo = async () => {
    if (name === "" || email === "") {
      Message.warning("Name and email is require");
      setName(personal.name);
      setEmail(personal.email);
      return;
    }
    try {
      setEditInfo(true);
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.patch(
        constants.url + "/user/edit",
        {
          user: {
            name: name,
            mail: email,
          },
        },
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      if (response.data.status === 202) {
        Message.success("User successfully edited");
        setEditInfo(false);
        dispatch(
          setUserInfo({
            personal: {
              name: response.data.result.user.name,
              id: response.data.result.user.id,
              email: response.data.result.user.mail,
              roleAdmin:response.data.result.user.roleAdmin
            },
          })
        );
      } else {
        Message.error(response.data.result.message);
        setName(personal.name);
        setEmail(personal.email);
        setEditInfo(false);
      }
    } catch (err) {
      Message.error("Communication error");
      setName(personal.name);
      setEmail(personal.email);
      setEditInfo(false);
    }
  };

  const editPasswordReq = async () => {
    if (password === "") {
      Message.warning("password is require");
      return;
    }
    setEditPassword(true);
    try {
      let token = localStorage.getItem("pnsToken");
      let response = await Axios.patch(
        constants.url + "/user/password",
        {
          user: {
            password: password,
          },
        },
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      if (response.data.status === 202) {
        Message.success("Password successfully edited");
        setEditPassword(false);
      } else {
        Message.error(response.data.result.message);
        setEditPassword(false);
      }
    } catch (err) {
      Message.error("Communication error");
      setEditPassword(false);
    }
  };
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={20} lg={20} xl={12}>
        <Card title="Profile" className="user-profile">
          <Row>
            <Divider>Edit Info</Divider>
            <Col
              className="user-profile-flex-column"
              xs={24}
              sm={20}
              md={15}
              lg={15}
            >
              <label className="user-profile-name">Name</label>
              <div className="user-profile-flex-in-column">
                <Input
                  value={name}
                  type="text"
                  className="user-profile-input"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  onBlur={(e) => {
                    setNameRequire(e.target.value.length < 1 ? true : false);
                  }}
                />
                {nameRequire ? (
                  <span className="user-profile-error-label">
                    {" "}
                    name is require
                  </span>
                ) : null}
              </div>
            </Col>
            <Col
              className="user-profile-flex-column"
              xs={24}
              sm={20}
              md={15}
              lg={15}
            >
              <label className="user-profile-name">Email</label>
              <div className="user-profile-flex-in-column">
                <Input
                  type="text"
                  className="user-profile-input"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  onBlur={(e) => {
                    let valid = Validation.emailValidation(e.target.value);
                    setMailValid(valid);
                    setMailRequire(e.target.value.length < 1 ? true : false);
                  }}
                />

                {mailRequire ? (
                  <span className="user-profile-error-label">
                    email is require
                  </span>
                ) : null}
                {!mailValid ? (
                  <span className="user-profile-error-label">
                    {" "}
                    email is incorrect{" "}
                  </span>
                ) : null}
              </div>
            </Col>
            <Col span={24}>
              <Button
                type="primary"
                onClick={EditInfo}
                loading={editInfo ? <Loading3QuartersOutlined spin /> : false}
                style={{
                  marginTop: "20px",
                }}
              >
                Save Changes
              </Button>
            </Col>
            <Divider>Edit Password</Divider>
            <Col
              className="user-profile-flex-column"
              xs={24}
              sm={20}
              md={15}
              lg={15}
            >
              <label className="user-profile-name">Password</label>
              <div className="user-profile-flex-in-column">
                <Input
                  type="text"
                  className="user-profile-input"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col span={24}>
              <Button
                type="primary"
                onClick={editPasswordReq}
                loading={editPassword ? <Loading3QuartersOutlined spin /> : false}
                style={{
                  marginTop: "20px",
                }}
              >
                Change Password
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
